import { DesignSet } from '@app/react/const/type';

type DesingSetID = { id: number | null, baseId: number | null };

const isNullUndef = <T>(value: T | null | undefined) => value === null || value === undefined;

export const isDesignSet = (lhs: DesignSet, { id, baseId }: DesingSetID): boolean => {
    if (isNullUndef(id) && isNullUndef(baseId)) {
        return false;
    }

    if (!isNullUndef(baseId)) {
        return baseId === lhs.baseId;
    }

    if (isNullUndef(baseId) && isNullUndef(lhs.baseId)) {
        return id === lhs.id;
    }

    return false;
};
